import CartePage from "./CartePage";
import { carteRestaurant } from "../data/menus";

const HERO = "/carte-restaurant.webp";

// Photos additionnelles réparties dans la carte (les photos pinnées par section sont gérées via menus.js)
const GALLERY = [
  "/tajine.webp",
  "/tapas.webp",
];

export default function CarteRestaurantPage() {
  return (
    <CartePage
      data={carteRestaurant}
      heroImg={HERO}
      galleryImgs={GALLERY}
      subtitleKey="restaurant"
      titleKey="restaurant"
      testid="page-carte-restaurant"
    />
  );
}
